exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.embed#form-page[data-v-8ac0001c] {\n    background: transparent;\n}\n.form-column[data-v-8ac0001c] {\n    max-width: 1280px;\n}\n.save-error[data-v-8ac0001c] {\n    margin: 16px 15px 0;\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: #fff1f1;\n    color: #c4363b;\n    font-size: 14px;\n}\n.steps.client-fields-above[data-v-8ac0001c] {\n    display: flex;\n    flex-direction: column;\n}\n.steps.client-fields-above .form-step[data-v-8ac0001c]:not(.active) {\n    display: none;\n}\n.steps.client-fields-above .form-step-client[data-v-8ac0001c] {\n    order: -1;\n    margin-bottom: 0;\n}\n", ""]);

// exports
